var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17.528,
  height: 17.811,
  viewBox: "0 0 17.528 17.811"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Path_84",
  "data-name": "Path 84",
  d: "M-4591.894-691.587h-4.312v16h16v-4.1",
  transform: "translate(4596.956 692.648)",
  fill: "none",
  stroke: "#212121",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3178",
  "data-name": "Group 3178",
  transform: "translate(7.297 1.061)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_85",
  "data-name": "Path 85",
  d: "M-4590.015-682.718l9.17-9.27",
  transform: "translate(4590.015 691.988)",
  fill: "none",
  stroke: "#212121",
  strokeLinecap: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_86",
  "data-name": "Path 86",
  d: "M-4587.394-691.587h6.091v5.81",
  transform: "translate(4590.756 691.587)",
  fill: "none",
  stroke: "#212121",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}))));
export default __webpack_public_path__ + "static/media/newtab.06c762bd.svg";
export { SvgComponent as ReactComponent };